import React from 'react';
import { motion } from 'framer-motion';
export function LoadingScreen() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center bg-[#0F1B2D]" data-id="element-3176">
      <div className="text-center space-y-8" data-id="element-3177">
        {/* Logo with pulse animation */}
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="flex justify-center" data-id="element-3178">
          <img src="https://cdn.magicpatterns.com/uploads/vqr9LriSp5eEW29oygg9EF/rabbit_logo_sidebar.svg" alt="Rabbit Gateway" className="h-16 w-auto object-contain" data-id="element-3179" />
        </motion.div>
        {/* Loading text */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="space-y-2" data-id="element-3180">
          <h2 className="text-xl font-semibold text-white" data-id="element-3181">
            Loading your dashboard
          </h2>
          <p className="text-sm text-gray-400" data-id="element-3182">Please wait a moment...</p>
        </motion.div>
        {/* Shimmer skeleton cards */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="grid grid-cols-3 gap-4 max-w-2xl mx-auto px-8" data-id="element-3183">
          {[1, 2, 3].map(i => <div key={i} className="bg-[#1A2A40] rounded-lg h-24 overflow-hidden relative" data-id="element-3184">
              <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent" animate={{
            x: ['-100%', '100%']
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'linear',
            delay: i * 0.2
          }} style={{
            backgroundSize: '200% 100%'
          }} data-id="element-3185" />
            </div>)}
        </motion.div>
        {/* Progress bar */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="max-w-xs mx-auto" data-id="element-3186">
          <div className="h-1 bg-[#1A2A40] rounded-full overflow-hidden" data-id="element-3187">
            <motion.div className="h-full bg-[#0066B3] rounded-full" initial={{
            width: '0%'
          }} animate={{
            width: '100%'
          }} transition={{
            duration: 2,
            ease: 'easeInOut'
          }} data-id="element-3188" />
          </div>
        </motion.div>
        {/* Spinning loader */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="flex justify-center" data-id="element-3189">
          <div className="w-8 h-8 border-3 border-[#F7941D] border-t-transparent rounded-full animate-spin" data-id="element-3190" />
        </motion.div>
      </div>
    </motion.div>;
}